import { useEffect, useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../FullscreenLoader/FullscreenLoader';
import { innerHtml } from '../../utils/utils';
import styles from './LegalDocument.module.scss';

const LegalDocumentComponent = ({ doc }: { doc: 'privacy' | 'cookie' | 'tos' }) => {
  const { getLegal } = useFirebase();
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState<string>(null);

  useEffect(() => {
    setLoading(true);
    getLegal(doc)
      .then(({ content }) => {
        setContent(content);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [doc]);

  if (loading) return <FullscreenLoader fullscreen={false} />;

  return <div className={`mt-5 ${styles.legalDocument}`} {...innerHtml(content)} />;
};

export { LegalDocumentComponent as LegalDocument };
